@if (!state.plan.isEnterprise) {
  @if (state.plan.product.isFree) {
    <b>
      @if (maxInviteCount() === 0) {
        No Seats Available.
      } @else {
        {{ maxInviteCount() }} Free
        @if (maxInviteCount() === 1) {
          Seat
        } @else {
          Seats
        }
        Available!
      }
    </b>
    Invite additional members on any premium plan.
    <a [routerLink]="['/a', 'pricing']" class="primary-link">Upgrade</a>
  } @else {
    @if (includedInviteCount() > 0) {
      <b
        >{{ includedInviteCount() }} Free Seats
        @if (!inviteCount()) {
          Available!
        } @else {
          (Invites Pending)
        }
      </b>
      Additional members join at
      @if (state.plan.price.billingFrequency === 'monthly') {
        {{ state.plan.price.amount | customCurrency }}/mo
      }
      @if (state.plan.price.billingFrequency === 'yearly') {
        {{ state.plan.price.amount | customCurrency }}/yr
      }
      upon acceptance.
    } @else {
      <b>Extend Your Team!</b> Additional members join at
      @if (state.plan.price.billingFrequency === 'monthly') {
        {{ state.plan.price.amount | customCurrency }}/mo
      }
      @if (state.plan.price.billingFrequency === 'yearly') {
        {{ state.plan.price.amount | customCurrency }}/yr
      }
      upon acceptance.
    }
  }
}
